import { rootStateBranchSelector } from '../utils/rootStateBranchSelector';

export const abGroupSelector = rootStateBranchSelector('abGroup');
